// Here we contain all the action types
export const ActionTypes = {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCT: "SELECTED_PRODUCT", // Will use whenever we click on any product to fetch its details
    REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
    SELECTED_CATEGORY: "SELECTED_CATEGORY",
    SELECTED_CART_PRODUCT: "SELECTED_CART_PRODUCT",
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
};